import { MainController } from './main.controller';

export const MainComponent = {
  template: require('./main.component.html'),
  controller: MainController,
};
